export function isAbsoluteUrl(url) {
  const regEg = new RegExp('^(?:[a-z+]+:)?//', 'i');
  return regEg.test(url);
}
